import { Component, Input } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  imports: [ProgressSpinnerModule],
})
export class LoaderComponent {
  @Input() message: string;
  @Input() loading: boolean;

  constructor() {}
}
